import { render, staticRenderFns } from "./CourseClubManage.vue?vue&type=template&id=b51be64c"
import script from "./CourseClubManage.vue?vue&type=script&lang=js"
export * from "./CourseClubManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports